import { render, staticRenderFns } from "./vip-home.vue?vue&type=template&id=a5f4ceac&scoped=true&"
import script from "./vip-home.vue?vue&type=script&lang=js&"
export * from "./vip-home.vue?vue&type=script&lang=js&"
import style0 from "./vip-home.vue?vue&type=style&index=0&id=a5f4ceac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f4ceac",
  null
  
)

export default component.exports